import React from 'react';
import PropTypes from 'prop-types';
import { PopOver, Tooltip } from 'components';
import { ReactComponent as Profile } from '../../../../../../assets/icons/profile-Icon.svg';
import { ReactComponent as ProfileWrapper } from '../../../../../../assets/icons/user-icon-wrapper.svg';
import { ReactComponent as User } from '../../../../../../assets/icons/user.svg';
import { ReactComponent as Notification } from '../../../../../../assets/icons/notification-icon.svg';
import { ReactComponent as LogoutIcon } from '../../../../../../assets/icons/logout-icon.svg';
import { useDispatch, useSelector } from 'react-redux';
import { logoutUser } from '../../../../../../store/user/actions';
import { Button } from 'components';
import isEmpty from 'lodash/isEmpty';
import { useNavigate } from 'react-router-dom';
import { Row } from 'antd';
import { useState, useEffect } from 'react';

const Logout = ({ user }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const locales = useSelector(state => state.forms?.localeStrings);
  const [visible, setVisible] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);


    return () => window.removeEventListener('resize', handleResize);
  }, []);


  const calculateOffset = () => {
    if (windowWidth < 1500) {
      const popoverWidth = 300;
      const rightMargin = 125;
      const desiredRightPosition = windowWidth - rightMargin - popoverWidth;

      const offset = -(windowWidth - desiredRightPosition - popoverWidth);

      return [offset, 0];
    }
    return [0, 0]; 
  };

  return (
    <PopOver
      open={visible}
      onOpenChange={setVisible}
      placement="bottom"
      autoAdjustOverflow={false}
      align={{
        offset: calculateOffset(),
      }}
      overlayStyle={{
        zIndex: 1000,
      }}
      TriggerComponent={
        <Tooltip
          placement="right"
          title="User Profile"
          className="header-profile-icon"
        >
          <Profile />
        </Tooltip>
      }
    >
      <div className="logout-popover__body">
        <div className="profile-header">
          <div className="profile-wrapper">
            <ProfileWrapper className="profile-icon-wrapper" />
            <Profile className="profile-icon" />
          </div>
          <div className="profile-info">
            <div className="fullname">{user.fullName}</div>
            <div className="email">{user.email}</div>
          </div>
        </div>
        {user.roleDescription && (
          <div className="role">{user.roleDescription}</div>
        )}
        {/* {getLocalString(locales, localNames.HOME_PAGE_LOGOUT)} */}

        <button
          className="menu-btn"
          onClick={() => navigate('/userProfileForm')}
        >
          <User className="menu-icon" />
          <span>Ο Λογαριασμός μου</span>
        </button>

        <button
          className="menu-btn"
          onClick={() => navigate('/notificationForm')}
        >
          <Notification className="menu-icon" />
          <span>Ειδοποιήσεις</span>
        </button>

        <button
          className="menu-btn"
          onClick={() => dispatch(logoutUser(navigate))}
        >
          <LogoutIcon className="menu-icon" />
          <span>Αποσύνδεση</span>
        </button>
      </div>
    </PopOver>
  );
};

Logout.propTypes = {
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
};

export default Logout;
